<div class="base-component">
  <div fxFill fxLayout="row">
    <div fxFlex="auto" fxLayoutAlign="center center">
      <img class="avatar" src="assets/img/avatar.png">
    </div>
    <div fxFlex="95" fxLayout="column" fxLayoutGap="5px">
      <h4 *ngIf="user" class="title text-hard-blue">{{ user.name }}</h4>
      <p>{{ createdAt }}</p>
    </div>
  </div>

  <app-call-user-agent
    [userAgent]="userAgentNormalized"
  ></app-call-user-agent>

  <div fxFill fxLayout="row">
    <div fxFlex="auto" fxLayoutAlign="center start" style="padding-top: 15px;">
      <mat-icon>chat_bubble_outline</mat-icon>
    </div>
    <div fxFlex="95" fxLayout="column" fxLayoutGap="5px">
      <div [innerHTML]="description"></div>
    </div>
  </div>

</div>
